const colours = {
    danger: '#B21418',
    success: '#6CB26A',
    primary: '#31153E',
    'fancyButt': '#F1EAD9',
};
export default colours;
